import { useContext } from "solid-js"
import { AppContext } from "./context"
import type { AppStore } from "./types"

/**
 * Hook to access AppStore from components
 * 
 * @returns [state, actions] tuple
 * @throws Error if used outside AppProvider
 * 
 * @example
 * const [app, appActions] = useAppStore()
 * console.log(app.mode)
 * appActions.setMode("simulate")
 */
export function useAppStore(): AppStore {
	const context = useContext(AppContext)
	if (!context) {
		throw new Error("useAppStore must be used within AppProvider")
	}
	return context
}
